import {Injectable} from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {Router} from '@angular/router';
import {MessageService} from "primeng/api";
import {APP_CONFIG} from "../../../environments/configurations/configurations";

export const toastConfig = {closable: true, life: APP_CONFIG.toasterLife};

@Injectable({
  providedIn: 'root',
})

export class ErrorHandlingInterceptor implements HttpInterceptor {
  constructor(private readonly router: Router, private readonly toaster: MessageService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap((event: HttpEvent<any>) => {
        },
        (error: any) => {
          if (error instanceof HttpErrorResponse) {
            if (error.status === 500)
              this.toaster.add({
                severity: 'error',
                summary: 'Server error',
                detail: error.error.message || 'Server Error Please Try Again Late',
                ...toastConfig
              });
            else if (error.status === 0)
              this.toaster.add({
                severity: 'error',
                summary: 'Connection Error',
                detail: error.error.message || 'Connection Error Please Try Again Later',
                ...toastConfig
              });
            else if (error.status === 401) {
              this.toaster.add({
                severity: 'error',
                summary: 'Authentication error',
                detail: error.error.message || 'Error Occurred Please Login Again',
                ...toastConfig
              });
              setTimeout(()=>this.router.navigate(['/login']),3000);
            }
            else if (error.status === 403)
            this.toaster.add({
                severity: 'error',
                summary: 'Registeration error',
              detail: error.error.message || 'Your account couldn\'t be registered. please contact system admin.',
                ...toastConfig
              });
            else {
              this.toaster.add({
                severity: 'error',
                summary: 'Server error',
                detail: error.error.message || 'Something Went Wrong Please Try Again',
                ...toastConfig
              });
            }
          }
        }
      )
    );
  }
}
